/**
 * The TanStack Query client.
 *
 * Query carries the cache invalidation after a state write, which design.md
 * § 3 calls the fiddliest part of the editing flow. The defaults here are
 * conservative: a 401 must never be retried, because retrying a dead session
 * just delays the redirect to login.
 */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError) {
            // Auth and permission answers are final; so are 404 and validation errors.
            if (error.status < 500) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        // A write is never retried automatically — a duplicated publish is worse
        // than a visible failure the user can repeat deliberately.
        retry: false,
      },
    },
  });
}
